/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const NatObj = require('../types/NatObj')
const NatCal = require('../types/NatCal')
const Dimf = require('../types/Dimf')
const Fonte = require('../types/Fonte')
const Opef = require('../types/Opef')
const Opef2v = require('../types/Opef2v')
const Opef3v = require('../types/Opef3v')
const Opef4v = require('../types/Opef4v')
const Opef5v = require('../types/Opef5v')
const Pointeur = require('../types/Pointeur')
const kernel = require('../kernel/kernel')
const DataInputStream = require('../entreesSorties/DataInputStream')
const Nat = require('../types/Nat')
const factory = require('../classes/objetFactory')
const CalcR = require('../kernel/CalcR')
const CalcC = require('../kernel/CalcC')

module.exports = CListeObjets

// Spécial JavaScript : une liste pourra avoir une id éventuelle qui sera celle de l'éventuel
// document qui la possède. Tous les objets graphiques ajoutés dans le DOM auront une id qui sera celle
// de la liste les possédant suivi de l'indice de l'objet dans la liste qui le possède
// mtg32.heapSizeMobile = 2 ; // le nombre maxi de move qu'on peut empiler pour périph mobile. Lus utilisé version 4.9.9.4
//mtg32.heapSizeWeb = 5; // le nombre maxi de move qu'on peut empiler pour navigateur
/**
 * Classe chargée de contenir  des objets numériques ou graphiques.
 * Utilisée pour contenir la liste principale des objets de la figure.
 * Peut aussi servir dans des objets de la liste.
 * Chaque élément de la liste possède un membre index qui donne son indice dans la Liste, pour
 * éviter les lenteurs de indexOf pour les listes avevc de nombreux objets.
 * Chaque fois que l'ordre des objets de la liste est modifié, il faut donc appeler updateIndexes.
 * Spécial JavaScript : une liste pourra avoir une id éventuelle qui sera celle de l'éventuel
 * Tous les objets graphiques ajoutés dans le DOM auront une id qui sera celle
 * de la liste les possédant suivi de l'indice de l'objet dans la liste qui le possède
 * document qui la possède.
 * @constructor
 * @param {kernel.uniteAngle} uniteAngle : L'unité d'angle de la figure.
 * @param {String} id : null ou l'id du svg associé pour la liste principale de la figure.
 * @returns {CListeObjets}
 */
function CListeObjets (uniteAngle, id) {
  this.col = []; // La liste effective des objets
  this.macroDemarrage = null;
  this.numeroVersion = DataInputStream.numeroVersionActif; // Rectifié version 4.8
  if (arguments.length === 0) {
    this.id = "";
    this.uniteAngle = kernel.uniteAngle.degre;
  }
  else {
    if (typeof uniteAngle === "string") {
      if (uniteAngle === "radian") this.uniteAngle = kernel.uniteAngle.radian;
      else this.uniteAngle = kernel.uniteAngle.degre;
    }
    else this.uniteAngle = uniteAngle; // Pourra être une chaîne de caractères en JavaScript
    if (arguments.length === 2) this.id = id;
    else this.id = "";
  }
  this.documentProprietaire = null;
  this.pointeurLongueurUnite = null;
  this.macroEnCours = null;
  this.macroParDefaut = null;
  // Spécial JavaScript pour gérer les traces
  // this.traces = new Array(); PLus utilisé version 4.9.9.4
  this.nbTraces = 0;
  // this.heapMove = [];
  // this.heapSize = mtg32.heapSizeWeb; PLus utilisé version 4.9.9.4
}
// On établit la distance considérée comme proche pour les outils de pointage suivant qu'on est sur périphérique mobile ou non
// CListeObjets.distanceMiniPourEtreProche =  /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? 20 : 10;
CListeObjets.nbMaxiTraces = 500; // Nombre maxi de traces
// CListeObjets.prototype = Object.create(Array.prototype);
CListeObjets.prototype.constructor = CListeObjets;
CListeObjets.prototype.className = "CListeObjets";

/**
 * Ajout version mtgApp
 * Si la liste est crée pour être interne à un document, this.documentProprietaire pointe sur ce document
 * Sinon this.documentProprietaire reste null
 * @param doc
 */
CListeObjets.prototype.associeA = function(doc) {
  this.documentProprietaire = doc;
};
/**
 * Ajoute l'élément elb à la liste.
 * @param {type} elb
 * @returns {undefined}
 */
CListeObjets.prototype.add = function(elb) {
	if (elb.listeProprietaire === this) elb.index = this.longueur(); // Modifié version 4.8.0
  this.col.push(elb);
};
/**
 * On retire éventuellement les CComponent instanciés par les objets sur le MtgInternalFrame
 * C'est le cas pour CEditeurFormule
 */
/**
 * Retire l'élement d'indice ind de la liste.
 * On retire éventuellement les composants du DOM instanciés par les objets (CEditeurFormule)
 * @param {integer} ind : L'indice de l'objet
 * @returns {Array}
 */
CListeObjets.prototype.remove = function(ind) { // elb est un objet
  var elb = this.get(ind);
  var liste = elb.listeProprietaire;
  if (liste !== null) {
    var doc = liste.documentProprietaire;
    if (doc !== null) {
      elb.deleteComponent(); // Nom changé par rapport à version Java.
    }
  }
  // Modifié version mtgApp
  /*
  var b = this.col.splice(ind,1);
  if (b) this.updateIndexes();
  */
  if (elb === this.pointeurLongueurUnite) this.pointeurLongueurUnite = null;
  this.col.splice(ind,1);
  // this.updateIndexes(); // Supprimé version mtgApp
  // return b;
};
// Spécial JavaScrit : met l'objet d'indice index à objet
/**
 * Remplace l'élement de la liste d'indice index par objet
 * @param {Integer} index
 * @param {CElementBase} objet
 * @returns {undefined}
 */
CListeObjets.prototype.set = function(index, objet) {
  this.col[index] = objet;
};
/**
 * Renvoie true si la liste contient l'objet ob
 * @param {CElementBase} ob
 * @returns {Boolean}
 */
CListeObjets.prototype.contains = function(ob) {
  return this.col.indexOf(ob) !== -1;
};
/**
 * Renvoie l'indice de l'objet ob dans la liste et -1 s'il n'y figure pas.
 * Si la liste est la liste propriétaire de ob, ob.index contient l'indice de ob.
 * @param {CElementBase} elb
 * @returns {Number}
 */
CListeObjets.prototype.indexOf = function(elb) {
  if (elb === null) return -1;
  if (elb.listeProprietaire === this) return elb.index;
  for (var i = 0; i < this.col.length; i++) {
    if (this.col[i] === elb) return i;
  }
  return -1;
};
/**
 * Fonction renvoyant la longueur de la liste.
 * @returns {Integer}
 */
CListeObjets.prototype.longueur = function() {
  return this.col.length;
};
/**
 * Renvoie l'élément elb de la liste d'indice indice saud si
 * l'argument cla est spécifié, et si cet élément elb est un CElementGenerique
 * (utilisé dans le simplémentations de constructions, renvoie un nouvel objet
 * nouv de classe cla tel que nouv.elementGeneriqueAssocie = elb.
 * @param {Integer} indice
 * @param {String} cla : Un nom de classe d'objet desendant de CElementBase
 * @returns {Array|CListeObjets.prototype.get.nouv|mtg32}
 */
CListeObjets.prototype.get = function(indice, cla) {
  if (indice === -1) return null;
  if (arguments.length === 1) return this.col[indice];
  var nouv = null;
  var elb = this.get(indice);
  if (elb.className === "CElementGenerique") {
    // On remplace le CElementGenerique par un nouvel objet de classe cla
    nouv = factory(cla, this);
    nouv.elementGeneriqueAssocie = elb;
    // On leurre le prototype en lui renvoyant un pointeur sur un élément pas
    // réellement implanté;
    return nouv;
  } else return this.col[indice];
};
/**
 * Fonction renvoyant l'élement de la liste dont le numéro d'identification est ind
 * ind est renvoyé par la version java de MathGraph32 soit par F5 (n° d'identification html)
 * ou par Aide - Info sur objet graphique.
 * @param {type} ind
 * @returns {CElementBase}
 */
CListeObjets.prototype.getById = function(ind) {
  var i,elb,ch;
  ch = this.id + "#" + ind;
  for (i = 0; i < this.longueur(); i++) {
    elb = this.get(i);
    if (elb.id === ch) return elb;
  }
  return null;
};
/**
 * Fonction initialisant l'unité d'angle et pointeurLongueurUnite
 * @param {kernel.uniteAngle} uniteAngle
 * @param {type} pointeurLongueurUnite
 * @returns {undefined}
 */
CListeObjets.prototype.initialise = function(uniteAngle, pointeurLongueurUnite) {
  this.pointeurLongueurUnite = pointeurLongueurUnite;
  this.uniteAngle = uniteAngle;
};
/**
 * Fonction renvoyant true si au moins un des objets de la liste dépend de ptel
 * @param {CElementBase} ptel
 * @returns {Boolean}
 */
CListeObjets.prototype.dependDe = function(ptel) {
  var resultat = false;
  for (var i = 0; i < this.col.length; i++) resultat = resultat || this.get(i).dependDe(ptel);
  return resultat;
};
/**
 * Fonction renvoyant true si au moins un des objets de la liste dépend de ptel
 * Utilisé pour les macros de boucle.
 * @param {CElementBase} ptel
 * @returns {Boolean}
 */
CListeObjets.prototype.dependDePourBoucle = function(ptel) {
  var resultat = false;
  for (var i = 0; (i < this.col.length) && !resultat; i++)
    resultat = resultat || this.get(i).dependDePourBoucle(ptel);
  return resultat;
};
/**
 * Fonction renvoyant true si au moins un des objets de la liste existe.
 * @returns {Boolean}
 */
CListeObjets.prototype.existeAuMoinsUnElement = function() {
  var resultat = false;
  for (var i = 0; (i < this.col.length) && !resultat; i++) resultat = resultat || this.get(i).existe;
  return resultat;
};
/**
 * Fonction initialisant this.nombreIterations à 0 avant un calcul de façon à ne pas faire
 * trop de boucles dans la produits et sommes indicés.
 * @returns {undefined}
 */
CListeObjets.prototype.initialiseNombreIterations = function() {
  this.nombreIterations = 0;
};
/**
 * Fonction ajoutant à this les éléments de la liste liste.
 * @param {CListeObjets} liste
 * @returns {undefined}
 */
CListeObjets.prototype.ajouteElementsDe = function(liste) {
  for (var i = 0; i < liste.col.length; i++) this.add(liste.get(i));
};
/**
 * Fonction ajoutant à this les points punaisés contenus dans list
 * @param {CListeObjets} list
 * @returns {undefined}
 */
CListeObjets.prototype.ajoutePointsPunaises= function(list) {
  for (var i = 0; i < list.col.length; i++) {
    var elb = list.get(i);
    if (!elb.estElementIntermediaire() && elb.estDeNature(NatObj.NPointMobile))
        if (!elb.estLibre()) this.add(elb);
  }
};
/**
 * Fonction ajoutant à this les éléments de list qui dépendent de ptel sauf exclu
 * @param {CElementBase} ptel
 * @param {CListeObjets} list
 * @param {CElementBase} exclu
 * @returns {undefined}
 */
CListeObjets.prototype.ajouteObjetsDependantsSauf = function(ptel, list, exclu) {
  for (var i = 0; i < list.col.length; i++) {
    var elb = list.get(i);
    if ((elb.dependDePourCapture(ptel)) && (elb !== exclu)) this.add(elb);
  }
};
/**
 * Fonction donnant le statut visible à tous les éléments graphiques de la liste.
 * @param {type} visible
 * @returns {undefined}
 */
CListeObjets.prototype.montreTout = function(visible) {
  for (var i = 0; i < this.col.length; i++) {
    var elb = this.get(i);
    if (elb.estDeNature(NatObj.NTtObj))
      if (visible) elb.montre(); else elb.cache();
  }
};
/**
 * Fonction retirant tous les objets de la liste.
 * A ne pas utiliser pour la liste principale quand on veut détruire tous ses objets
 * car les évntuels composants créés ne sont pas détruits.
 * @returns
 */
/**
 * Fonction retirant tous les objets de la liste.
 * A ne pas utiliser pour la liste principale quand on veut détruire tous ses objets
 * car les évntuels composants créés ne sont pas détruits.
 * @param bdeletePointeurListe : Si présent et true, on retire l'association entre chaque élément et sa liste proprietaire
 */
CListeObjets.prototype.retireTout = function(bdeletePointeurListe) {
  if ((arguments.length !== 0) && bdeletePointeurListe) {
    for (var i = 0; i < this.longueur(); i++) {
      var el = this.get(i);
      el.listeProprietaire = null;
    }
  }
  this.col.splice(0, this.col.length);
};
/**
 * Fonction rajoutant à listeCible des clones de tous les éléments de this
 * @param {CListeObjets} listeCible
 * @returns {undefined}
 */
CListeObjets.prototype.setCopy = function(listeCible) {
  listeCible.documentProprietaire = this.documentProprietaire;
  listeCible.id = this.id;
  listeCible.uniteAngle = this.uniteAngle; // Avant le recalcul
  for (var i = 0; i < this.col.length; i++) {
    listeCible.add(this.get(i).getClone(this, listeCible));
  }
  if (this.pointeurLongueurUnite !== null)
    listeCible.pointeurLongueurUnite = listeCible.get(this.indexOf(this.pointeurLongueurUnite));
  else listeCible.pointeurLongueurUnite = null;
    listeCible.etablitListesInternesMacros();
};
/**
 * Cette fonction fait de la liste this dans listeProprietaireCible l'équivalent
 * de ce qu'est listeSource dans listePropretaireSource.
 * ListeProprietaireCible doit être une liste clonée.
 * @param {CListeObjets} listeSource
 * @param {CListeObjets} listeProprietaireSource
 * @param {CListeObjets} listeProprietaireCible
 * @returns {undefined}
 */
CListeObjets.prototype.setImage = function(listeSource, listeProprietaireSource, listeProprietaireCible) {
  for (var i = 0; i < listeSource.col.length; i++) {
    var elb = listeSource.get(i);
    var indexSource = listeProprietaireSource.indexOf(elb);
    var elbCible = listeProprietaireCible.get(indexSource, "CElementBase");
    this.add(elbCible);
  }
  this.uniteAngle = listeSource.uniteAngle;
  if (listeSource.pointeurLongueurUnite !== null)
    this.pointeurLongueurUnite = this.get(listeSource.indexOf(listeSource.pointeurLongueurUnite));
};
/**
 * Fonction faisant de la liste en cours une copie de listeSource (en faisant
 * en sorte que leurs objets aient les mêmes caractéristiques)
 * @param {CListeObjets} listeSource
 * @returns {undefined}
 */
CListeObjets.prototype.setClone = function(listeSource) {
  var index = 0;
  while ((index < this.col.length) && (index < listeSource.col.length)) {
    var elbSource = listeSource.get(index);
    var elb = this.get(index);
    elb.setClone(elbSource);
    index++;
  }
};
/**
 * Fonction recalculant tous les éléments de la liste sauf les calculs de dérivées
 * ou test d'équivalence de calculs ou tests de factorisation.
 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
 * pour fournir de nouveaux résultats aléatoires.
 * @param {Dimf} dimfen
 * @returns {undefined}
 */
CListeObjets.prototype.positionne = function(infoRandom, dimfen) {
  for (var i = 0; i < this.col.length; i++)
    this.get(i).positionne(infoRandom, dimfen);
};
/**
 * Fonction recalculant tous les éléments de la liste y compris les calculs de dérivées
 * ou test d'équivalence de calculs ou tests de factorisation.
 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
 * pour fournir de nouveaux résultats aléatoires.
 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
 * pour fournir de nouveaux résultats aléatoires.
 * @param {Dimf} dimfen
 * @returns {undefined}
 */
CListeObjets.prototype.positionneFull = function(infoRandom, dimfen) {
  for (var i = 0; i < this.col.length; i++)
    this.get(i).positionneFull(infoRandom, dimfen);
};
// Fonction ne recalculant que les objets non graphiques de la figure.
/**
 * Fonction ne recalculant que les objets non graphiques de la figure, y compris les calculs de dérivées
 * ou test d'équivalence de calculs ou tests de factorisation.
 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
 * pour fournir de nouveaux résultats aléatoires.
 * @param {Dimf} dimfen
 * @returns {undefined}
 */
CListeObjets.prototype.positionneFullNG = function(infoRandom, dimfen) {
  for (var i = 0; i < this.col.length; i++) {
    var el = this.get(i);
    if (el.getNature() === NatObj.NAucunObjet) el.positionneFull(infoRandom, dimfen);
  }
};
/**
 * Fonction ne recalculant que les éléments de la figure qui dépendent de pt
 * @param {Booelan} infoRandom : Si true tous les calculs avec rand() sont recalculés
 * pour fournir de nouveaux résultats aléatoires.
 * @param {Dimf} dimfen
 * @param {type} pt
 * @returns {undefined}
 */
CListeObjets.prototype.positionneDependantsDe = function(infoRandom, dimfen, pt) {
  for (var i = 0; i < this.col.length; i++) {
    var elb = this.get(i);
    if (elb.dependDe(pt)) elb.positionne(infoRandom, dimfen);
  }
};
/**
 * Fonction recherchant les éléments graphiques de la figure qui sont proche de point
 * sauf ceux qui sont compris dans listeExclusion.
 * @param {Nat} typeCherche : Indique quels sont le ou les types d'objest cherchés.
 * @param {type} point : Contient les coordonnées du pointeur souris.
 * @param {InfoProx} info : Mémorise les infos sur les objets proches.
 * @param {CListeObjets} listeExclusion : iste contenant les objets exclus de la recherche
 * (par exemple les points punaisés).
 * @param {type} prioritePoints : Si true on donne une priorité aux points dans la recherche.
 * @param deviceType {String} : "mouse" pour un appel depuis un événement souris et "touch" pour un tactile
 * @param bModifiableParMenu {boolean}  : true si on ne veut désigner que les éléments modifiables par un menu
 * @param {boolean} bMemeMasque : true si on recherche aussi parmi les éléments masqués
 * @returns {Number}
 */
CListeObjets.prototype.procheDe = function(typeCherche, point, info, listeExclusion, prioritePoints,
                                           deviceType, bmodifiableParMenu, bMemeMasque) {
  var ind,indnat,nat,ptel,dis,b;
  if (this.longueur() === 0) return 0;
  var bModifParMenu = arguments.length < 7 ? false : bmodifiableParMenu;
  var bmmMasque = arguments.length < 8 ? false : bMemeMasque;
  info.metAZero();
  // On traite tous les éléments de la liste
  for (var i = 0; i < this.col.length; i++){
    ptel =  this.get(i);
    if (listeExclusion.indexOf(ptel) === -1) {
      nat = ptel.getNature();
      b = nat.isOfNature(typeCherche);
      if (bModifParMenu) b = b && ptel.modifiableParMenu();
      if (b) {
        // ptelg = (CElementGraphique) ptel;
        // if ((!ptel.masque || bmmMasque) && !ptel.estElementIntermediaire()) {
        if (!ptel.estElementIntermediaire()) {
          const distmin = deviceType === "touch" ? kernel.distMinForTouch : kernel.distMinForMouse;
          dis = ptel.distancePoint(point.x, point.y, !bmmMasque, distmin);
          if ((dis !== -1) && (dis < distmin)){
            info.typesProches = Nat.or(info.typesProches, nat);
            indnat = NatObj.indiceDeNature(nat);
            info.infoParType[indnat].nombreVoisins++;
            if (nat.isOfNature(NatObj.NTtPoint)){
              info.nombrePointsVoisins++;
              if (info.premierPointVoisinRencontre) {
                info.premierPointVoisin = ptel;
                info.dernierPointVoisin = ptel;
                info.premierPointVoisinRencontre = false;
              } else info.dernierPointVoisin = ptel;
            }
            if (info.infoParType[indnat].premierVoisinRencontre) {
              info.infoParType[indnat].premierVoisin = ptel;
              info.infoParType[indnat].premierVoisinRencontre = false;
            } else {
              info.infoParType[indnat].dernierVoisin = ptel;
            }
          }
        }
      }
    }
  }
  if (prioritePoints && (info.nombrePointsVoisins > 0)) {
    info.metAZeroObjetsNonPoints();
    info.typesProches = Nat.and(info.typesProches, NatObj.NTtPoint);
  }
  info.nombreObjetsProches = 0;
  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
    info.nombreObjetsProches += info.infoParType[ind].nombreVoisins;
  }
  info.nombreTypesProches = 0;
  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
    if (Nat.and(info.typesProches,NatObj.conversionNumeroNature[ind]).isNotZero()) info.nombreTypesProches++;
  }
  return info.nombreObjetsProches;
};
/**
 * Fonction recherchant les éléments graphiques de la figure qui sont proche de point
 * et qui sont capturables à la souris, sauf ceux qui sont compris dans listeExclusion.
 * @param {Nat} typeCherche : Indique quels sont le ou les types d'objest cherchés.
 * @param {type} point : Contient les coordonnées du pointeur souris.
 * @param {InfoProx} info : Mémorise les infos sur les objets proches.
 * @param {CListeObjets} listeExclusion : iste contenant les objets exclus de la recherche
 * (par exemple les points punaisés).
 * @param {type} prioritePoints : Si true on donne une priorité aux points dans la recherche.
 * @param deviceType {String} : "mouse" pour un appel depuis un événement souris et "touch" pour un tactile
 * @returns {Number}
 */
CListeObjets.prototype.procheDePourCapture = function(typeCherche, point, info, listeExclusion, prioritePoints, deviceType) {
  var ind, indnat;
  var nat;
  var ptel;
  var dis;
  if (this.longueur() === 0) return 0;
  info.metAZero();
  // On traite tous les éléments de la liste
  for (var i=0; i < this.col.length; i++) {
    ptel =  this.get(i);
    if (ptel.estCapturableSouris() && listeExclusion.indexOf(ptel) === -1) {
      nat = ptel.getNature();
      if (nat.isOfNature(typeCherche)) {
        // Modification par rapport au C++
        // ptelg = (CElementGraphique) ptel;
        if (!ptel.masque && !ptel.estElementIntermediaire()) {
          const distmin = deviceType === "touch" ? kernel.distMinForTouch : kernel.distMinForMouse;
          dis = ptel.distancePoint(point.x, point.y, true, distmin);
          if ((dis !== -1) && (dis < distmin)){
            info.typesProches = Nat.or(info.typesProches, nat);
            indnat = NatObj.indiceDeNature(nat);
            info.infoParType[indnat].nombreVoisins++;
            if (nat.isOfNature(NatObj.NTtPoint)){
              info.nombrePointsVoisins++;
              if (info.premierPointVoisinRencontre) {
                info.premierPointVoisin = ptel;
                info.dernierPointVoisin = ptel;
                info.premierPointVoisinRencontre = false;
              } else info.dernierPointVoisin = ptel;
            }

            if (info.infoParType[indnat].premierVoisinRencontre) {
              info.infoParType[indnat].premierVoisin = ptel;
              info.infoParType[indnat].premierVoisinRencontre = false;
            } else info.infoParType[indnat].dernierVoisin = ptel;
          }
        }
      }
    }
  }

  // Si prioritePoint est true, priorités aux objets points sauf si on est proche d'un repère
  if (prioritePoints && (info.nombrePointsVoisins > 0)) {
    info.metAZeroObjetsNonPoints(); // Ajouté version 2.7
    info.typesProches = Nat.and(info.typesProches, NatObj.NTtPoint); // Car un repère se désigne par son origine ds la version java
  }
  info.nombreObjetsProches = 0;
  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++)
    info.nombreObjetsProches += info.infoParType[ind].nombreVoisins;
  info.nombreTypesProches = 0;
  for (ind = 0; ind < NatObj.nombreTypesDesignables; ind++) {
    if (Nat.and(info.typesProches,NatObj.conversionNumeroNature[ind]).isNotZero()) info.nombreTypesProches++;

  }
  return info.nombreObjetsProches;
};

/**
 * Renvoie un pointeur sur le calcul ou la fonction de nom nom dont le test nat & NatCal est non nul
 * @param {mtg32.Nature} nat
 * @param {String} nom
 * @param {Integer} indiceMaxi : -1 pour une recherche dans toute la liste et sinon l'indice mai de la recherche.
 * @returns {CElementBase} : Retourne null si la recherche n'a pas abouti.
 */
CListeObjets.prototype.pointeurParNatureCalcul = function(nat, nom, indiceMaxi) {
  var indmax;
  if (arguments.length <= 2) indmax = this.longueur() - 1;
  else indmax = indiceMaxi;
  if (indmax === -1) indmax = this.longueur() - 1;
  var i = 0;
  var elb = null;
  var trouve = false;
  while ((!(trouve)) && (i <= indmax)) {
    elb =  this.get(i);
    if (elb.estDeNatureCalcul(nat)) {
      if (elb.getNom() === nom) trouve = true;
      else i++;
    } else i++;
  }
  if (trouve) return elb; else return null;
};
/**
 * Fonction appelant etablitListesInternes pour toutes les macros contenues dans la liste.
 * @returns {undefined}
 */
CListeObjets.prototype.etablitListesInternesMacros = function() {
  for(var i = 0; i < this.col.length; i++) {
    var elb =  this.get(i);
    if (elb.getNature() === NatObj.NMacro)
      elb.etablitListesInternes();
  }
};
/**
 * Fonction renvoyant un pointeur sur la première macro dont l'intitulé est intitule.
 * Renvoie null si la rechercha n'a pas abouti.
 * @param {String} intitule : Intitulé de la macro recherchée.
 * @returns {CMacro}
 */
CListeObjets.prototype.pointeurMacro = function(intitule) {
  for (var i = 0; i < this.col.length; i++) {
    var elb =  this.get(i);
    if (elb.getNature() === NatObj.NMacro) {
      if (elb.intitule === intitule) return elb;
    }
  }
  return null;
};
/**
 * Fonction recherchant dans la liste une valeur réelle (qui n'est pas un élément
 * intermédiaire de construction) dont le nom commence par ch
 * Si elle est trouvée, renvoie la longueur du nom désignant la valeur
 * (par  exemple AOB pour une mesure d'angle ou le nom d'un calcul)
 * et pointeurValeur.getValue() renvoie un pointeur sur cette valeur.
 * @param {String} ch : La chaine recherchée
 * @param {Pointeur} pointeurValeur
 * @returns {Integer}
 */
CListeObjets.prototype.commenceParNomValeur = function(ch, pointeurValeur) {
  var longueurNom = {x:0};
  var longueurTrouvee = 0;
  for(var i = 0; i < this.col.length; i++) {
    var elb =  this.get(i);
    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(NatCal.NTteValR)) {
      // ptv = (CValDyn) elb;
      if (elb.chaineCommenceParNom(ch, longueurNom) && (longueurNom.x > longueurTrouvee)) {
        longueurTrouvee = longueurNom.x;
        pointeurValeur.setValue(elb);
      }
    }
  }
  return longueurTrouvee;
};
/**
 * Fonction recherchant dans la liste une valeur réelle complexe (qui n'est pas
 * un élément intermédiaire de construction) dont le nom commence par ch.
 * Si elle est trouvée, renvoie la longueur du nom désignant la valeur
 * (par  exemple AOB pour une mesure d'angle ou le nom d'un calcul)
 * et pointeurValeur.getValue() renvoie un pointeur sur cette valeur.
 * @param {String} ch : La chaine recherchée
 * @param {Pointeur} pointeurValeur
 * @returns {Integer}
 */
CListeObjets.prototype.commenceParNomValeurReelleOuComplexe = function(ch, pointeurValeur) {
  var longueurNom = {x:0};
  var longueurTrouvee = 0;
  for (var i = 0; i < this.col.length; i++) {
    var elb =  this.get(i);
    if (! elb.estElementIntermediaire() && elb.estDeNatureCalcul(NatCal.NTteValROuC)) {
      if (elb.chaineCommenceParNom(ch, longueurNom) && (longueurNom.x > longueurTrouvee)) {
        longueurTrouvee = longueurNom.x;
        pointeurValeur.setValue(elb);
      }
    }
  }
  return longueurTrouvee;
};
/**
 * Fonction recherchant dans la liste une fonction ou une suite réelle définie
 * par l'utilisateur (qui n'est pas un élément intermédiaire de construction)
 * dont le nom commence par ch.
 * Si elle est trouvée, renvoie la longueur du nom de la fonction ou suite trouvée
 * et pointeurFonction.getValue() renvoie un pointeur sur la fonction.
 * @param {String} ch
 * @param {Pointeur} pointeurFonction
 * @returns {Number}
 */
CListeObjets.prototype.commenceParNomFonctionUtilisateur = function(ch, pointeurFonction) {
  // CCalculAncetre ptf;
  var longueurNom = {x:0};
  var longueurTrouvee = 0;
  pointeurFonction.setValue(null);
  for(var i = 0; i < this.col.length; i++) {
    var elb =  this.get(i);
    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncR
        ,NatCal.NDerivee , NatCal.NTteSuiteRecR))) {
      if (elb.chaineCommenceParNom(ch, longueurNom) && (longueurNom.x > longueurTrouvee)) {
        longueurTrouvee = longueurNom.x;
        pointeurFonction.setValue(elb);
      }
    }
  }
  return longueurTrouvee;
};
/**
 * Fonction recherchant dans la liste une fonction ou une suite complexe définie
 * par l'utilisateur (qui n'est pas un élément intermédiaire de construction)
 * dont le nom commence par ch.
 * Si elle est trouvée, renvoie la longueur du nom de la fonction ou suite trouvée
 * et pointeurFonction.getValue() renvoie un pointeur sur la fonction.
 * @param {String} ch
 * @param {Pointeur} pointeurFonction
 * @returns {Integer}
 */
CListeObjets.prototype.commenceParNomFonctionComplexeUtilisateur = function(ch, pointeurFonction) {
  var longueurNom = {x:0};
  var longueurTrouvee = 0;
  pointeurFonction.setValue(null);
  for(var i = 0; i < this.col.length; i++) {
    var elb =  this.get(i);
    if (!elb.estElementIntermediaire() && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncRouC,
      NatCal.NTteSuiteRecC))) {
      if (elb.chaineCommenceParNom(ch, longueurNom) && (longueurNom.x > longueurTrouvee)) {
        longueurTrouvee = longueurNom.x;
        pointeurFonction.setValue(elb);
      }
    }
  }
  return longueurTrouvee;
};
/**
 * Fonction utilisée dans CCb  renvoyant 0 si la chaine pointée par ch ne
 * pointe pas sur une chaine représentant une valeur ou une fonction mathématique prédéfinie ou
 * une fonction définie par l'utilisateur ou un parametre.
 * Les objets intermédiaires de constructions sont sautés dans la recherche.
 * Sinon, elle renvoie  la longueur du nom le plus long trouve.
 * Si ParametreTrouve.getValue est non null, c'est qu'on a trouvé le paramètre formel
 * et parametreTrouve.getValue contient son indice dans le tableau parametreFormel,
 * sinon, si PointeurValeur est différent de NULL, c'est qu'un a trouvé un nom de valeur ou de fonction
 * définie par l'utilisateur (les suites étant considérées comme des
 * fonctions) sinon c'est qu'on a trouvé un nom de fonction prédéfinie dont
 * la nature est renvoyée dans nomFonction.
 * Les calculs intermédiaires sont exclus de la recherhce.
 * @param {String} ch : La chaîne recherchée.
 * @param {Array} parametreFormel : null ou un tableau contenant les paramètres formels recherchés
 * @param {Pointeur} pointeurValeur : Si on a trouvé une valeur, pointeurValeur.getValue()
 * renvoie un pointeur sur celle-ci.
 * @param {Pointeur} nomFonction : nomFonction.getValue() renvoie la longueur du nom de la fonction trouvée
 * ou 0 si non trouvée.
 * @param {Pointeur} parametreTrouve : parametreTrouve.getValue renvoie -1 si le paramètre n'a pas été trouvé
 * ou sinon son indice dans le tableau parametreFormel
 * @param {Pointeur} nombreVariables : Renvoie par getValue() le nombre de paramètres formels de la fonction trouvée.
 * @returns {Integer}
 */
CListeObjets.prototype.commenceParNomFonctionOuValeurOuParametre = function(ch, parametreFormel,
    pointeurValeur, nomFonction, parametreTrouve, nombreVariables) {
  const CCbGlob = require('../kernel/CCbGlob')
  var longueurNomFonctionPredefinie;
  var longueurNomValeur;
  var pointeurSurValeur = new Pointeur(null);
  var pointeurSurFonction = new Pointeur(null);
  var longueurNomFonctionUtilisateur;
  var indiceParametre = -1;
  var longueurNomParametre = 0;
  parametreTrouve.setValue(-1);
  if (parametreFormel !== null) {
    for (var i = 0; i < parametreFormel.length; i++) {
      if ((ch.indexOf(parametreFormel[i])===0) && (parametreFormel[i].length > longueurNomParametre)) {
        longueurNomParametre = parametreFormel[i].length;
        indiceParametre = i;
        parametreTrouve.setValue(i); // Ligne rajoutée version 4.5.2
      }
    }
  }
  longueurNomFonctionPredefinie = CCbGlob.commenceParNomFonctionReellePredefinie(ch, nomFonction, nombreVariables);
  longueurNomValeur = this.commenceParNomValeur(ch, pointeurSurValeur);
  longueurNomFonctionUtilisateur = this.commenceParNomFonctionUtilisateur(ch, pointeurSurFonction);
  if ((longueurNomFonctionPredefinie === 0) && (longueurNomValeur === 0)
      && (longueurNomFonctionUtilisateur === 0) && (longueurNomParametre === 0)) {
    return 0;
  } else {
    if ((longueurNomParametre >= longueurNomFonctionPredefinie)
        && (longueurNomParametre >= longueurNomValeur)
        && (longueurNomParametre >= longueurNomFonctionUtilisateur)) {
      parametreTrouve.setValue(indiceParametre);
      return longueurNomParametre;
    } else {
      parametreTrouve.setValue(-1);
      if ((longueurNomFonctionPredefinie > longueurNomValeur)
          && (longueurNomFonctionPredefinie > longueurNomFonctionUtilisateur)
          && (longueurNomFonctionPredefinie > longueurNomParametre)) {
        pointeurValeur.setValue(null);
        return longueurNomFonctionPredefinie;
      } else {
        if ((longueurNomValeur > longueurNomFonctionPredefinie)
            && (longueurNomValeur > longueurNomFonctionUtilisateur)
            && (longueurNomValeur > longueurNomParametre)) {
          pointeurValeur.setValue(pointeurSurValeur.getValue());
          return longueurNomValeur;
        } else {
          if ((longueurNomFonctionUtilisateur > longueurNomFonctionPredefinie)
              && (longueurNomFonctionUtilisateur > longueurNomValeur)
              && (longueurNomFonctionUtilisateur > longueurNomParametre)) {
            pointeurValeur.setValue(pointeurSurFonction.getValue());
            nombreVariables.setValue(pointeurSurFonction.getValue().nombreVariables());
            return longueurNomFonctionUtilisateur;
          } else return 0;
        }
      }
    }
  }
};
/**
 * Fonction utilisée dans CCb  renvoyant 0 si la chaine pointée par ch ne
 * pointe pas sur une chaine représentant une valeur réelle ou complexe
 * ou une fonction mathématique complexe prédéfinie ou
 * une fonction complexe définie par l'utilisateur ou un parametre.
 * Les objets intermédiaires de constructions sont sautés dans la recherche.
 * Sinon, elle renvoie  la longueur du nom le plus long trouve.
 * Si aucune fonction ou valeur ou paramètre n'est trouvé et si la chapine commence par la lettre i
 * complexiTrouve.getValue() renvoie true, sinon false.
 * Si ParametreTrouve.getValue est non null, c'est qu'on a trouvé le paramètre formel
 * et parametreTrouve.getValue contient son indice dans le tableau parametreFormel,
 * Sinon, si PointeurValeur est différent de NULL, c'est qu'un a trouvé un nom de valeur ou de fonction
 * définie par l'utilisateur (les suites étant considérées comme des
 * fonctions) sinon c'est qu'on a trouvé un nom de fonction prédéfinie dont
 * la nature est renvoyée dans nomFonction.
 * Les calculs intermédiaires sont exclus de la recherhce.
 * @param {String} ch : La chaîne dans laquelle se fait la recherche
 * @param {Array} parametreFormel : null ou un tableau contenant les paramètres formesl recherchés.
 * @param {Pointeur} pointeurValeur : : Si on a trouvé une valeur, pointeurValeur.getValue()
 * renvoie un pointeur sur celle-ci.
 * @param {Pointeur} nomFonction : nomFonction.getValue() renvoie la longueur du nom de la fonction trouvée
 * ou 0 si non trouvée.
 * @param {Pointeur} parametreTrouve : parametreTrouve.getValue renvoie -1 si le paramètre n'a pas été trouvé
 * ou sinon son indice dans le tableau parametreFormel
 * @param {type} complexeiTrouve : complexeiTrouve.ggetValue renvoie true si aucune fonction
 * ou valeur n'a été trouvée mais la chaîne commence par la lettre i.
 * @param {Pointeur} nombreVariables : Renvoie par getValue() le nombre de paramètres formels de la fonction trouvée.
 * @returns {Integer}
 */
CListeObjets.prototype.commenceParNomFonctionOuValeurOuParametreComplexe = function(ch, parametreFormel,
    pointeurValeur, nomFonction, parametreTrouve, complexeiTrouve, nombreVariables) {
  const CCbGlob = require('../kernel/CCbGlob')
  var longueurNomFonctionPredefinie;
  var longueurNomValeur;
  var pointeurSurValeur = new Pointeur();
  var pointeurSurFonction = new Pointeur();
  var longueurNomFonctionUtilisateur;
  var indiceParametre = -1;
  var longueurNomParametre = 0;

  parametreTrouve.setValue(-1);
  complexeiTrouve.setValue(false);
  pointeurValeur.setValue(null);
  if (parametreFormel !== null) {
    for (var i = 0; i < parametreFormel.length; i++) {
      if ((ch.indexOf(parametreFormel[i])===0) && (parametreFormel[i].length > longueurNomParametre)) {
        longueurNomParametre = parametreFormel[i].length;
        indiceParametre = i;
        parametreTrouve.setValue(i); // Ligne rajoutée version 4.5.2
      }
    }
  }
  longueurNomFonctionPredefinie = CCbGlob.commenceParNomFonctionComplexePredefinie(ch, nomFonction, nombreVariables);
  longueurNomValeur = this.commenceParNomValeurReelleOuComplexe(ch, pointeurSurValeur);
  longueurNomFonctionUtilisateur = this.commenceParNomFonctionComplexeUtilisateur(ch, pointeurSurFonction);
  if ((longueurNomFonctionPredefinie === 0) && (longueurNomValeur === 0)
      && (longueurNomFonctionUtilisateur === 0) && (longueurNomParametre === 0)) {
    if (ch.indexOf("i")===0) {
      complexeiTrouve.setValue(true);
      return 1;
    } else return 0;
  } else {
    if ((longueurNomParametre >= longueurNomFonctionPredefinie)
        && (longueurNomParametre >= longueurNomValeur)
        && (longueurNomParametre >= longueurNomFonctionUtilisateur)) {
      parametreTrouve.setValue(indiceParametre);
      return longueurNomParametre;
    } else {
      parametreTrouve.setValue(-1); // Correction bug version 46
      if ((longueurNomFonctionPredefinie > longueurNomValeur)
          && (longueurNomFonctionPredefinie > longueurNomFonctionUtilisateur)
          && (longueurNomFonctionPredefinie > longueurNomParametre)) {
        return longueurNomFonctionPredefinie;
      } else {
        if ((longueurNomValeur > longueurNomFonctionPredefinie)
            && (longueurNomValeur > longueurNomFonctionUtilisateur)
            && (longueurNomValeur > longueurNomParametre)) {
          // On teste si on fait référence à un calcul ou une variable nommé i.
          // Si c'est le cas, on donne priorité au complexe i
          if ((longueurNomValeur === 1) && ch.indexOf("i")===0) {
            complexeiTrouve.setValue(true);
            return 1;
          } else {
            pointeurValeur.setValue(pointeurSurValeur.getValue());
            return longueurNomValeur;
          }
        } else {
          if ((longueurNomFonctionUtilisateur > longueurNomFonctionPredefinie)
              && (longueurNomFonctionUtilisateur > longueurNomValeur)
              && (longueurNomFonctionUtilisateur > longueurNomParametre)) {
            nombreVariables.setValue(pointeurSurFonction.getValue().nombreVariables());
            pointeurValeur.setValue(pointeurSurFonction.getValue());
            return longueurNomFonctionUtilisateur;
          } else return 0;
        }
      }
    }
  }
};
/**
 * Fonction ajoutant à la liste this des clones de ptelg, au nombre de nombreCopies.
 * Utilisé dans les leiu d'objets.
 * @param {CElementGraphique} ptelg
 * @param {type} nombreCopies
 * @returns {undefined}
 */
CListeObjets.prototype.ajouteClonesDe = function(ptelg, nombreCopies) {
  for (var i = 0; i < nombreCopies; i++) {
    var el = ptelg.creeClone();
    el.impProto = null; // Pour qu'un élément cloné d'un élément intermédiaire ne soit pas considéré comme obbjet intermémdiaire
    this.add(el);
  }
};

CListeObjets.prototype.initialiseDependances = function() {
  for (var i = 0; i < this.col.length; i++) {
    var elb = this.get(i);
    elb.initialisePourDependance();
  }
};

/**
 * Fonction chargeant la liste depuis un fux de données binaires.
 * @param {DataInputStream} inps
 * @returns {undefined}
 */
CListeObjets.prototype.read = function(inps) {
  try {
    // On lit d'abord l'unité d'angle
    this.uniteAngle = inps.readInt();
    // On lit d'abord le nombre d'objets de la liste
    this.nombreObjets = inps.readInt();
    for (var i = 0; (i < this.nombreObjets); i++) {
      var elb = inps.readObject(this);
      elb.index = i; // Rajouté version 4.8.0
      this.add(elb);
      // Spécial JavaScript : chaque élément graphique a une id qui est l'id de la liste
      // qui le possède suivi de son indice dans la liste à partir de 0
      if (this.className !== "CPrototype") elb.id = this.id + "#" + i;
    }
    var indiceLongueurUnite = inps.readInt();
    if (indiceLongueurUnite === -1) this.pointeurLongueurUnite = null;
    else this.pointeurLongueurUnite = this.get(indiceLongueurUnite);
    // Inutile dans l'applet
    var indiceMacroParDefaut = inps.readInt();
    if (indiceMacroParDefaut !== -1) this.macroParDefaut = this.get(indiceMacroParDefaut);
    else this.macroParDefaut = null;
    // Nouveau version 4.8
    if (this.numeroVersion < 12) this.macroDemarrage = null;
    else {
      var indiceMacroDemarrage = inps.readInt();
      if (indiceMacroDemarrage === -1) this.macroDemarrage = null;
      else  this.macroDemarrage = this.get(indiceMacroDemarrage);
    }
    this.etablitListesInternesMacros();
  }
  catch  (e) {
    throw new Error("IOException");
  }
};
/**
 * Fonction renvoyant true seulement si nom est valide pour un nouveau nom de calcul ou de fonction
 * N'affiche pas de message en cas d'erreur
 * les paramètres formels de fonctions sont autorisés
 * @param {String} chNom
 * @returns {Boolean}
 */
CListeObjets.prototype.validationNomCalculSansMessage = function(chNom) {
  const CCbGlob = require('../kernel/CCbGlob')
  if ((chNom.length === 0) || !this.validationNomVariableOuCalcul(chNom)) return false;
  if (chNom === "i") return false;
  if (CCbGlob.egalNomFonctionReelleOuComplexePredefinie(chNom)) return false;
  return (!this.egalNomValeurOuFonctionOuMesure(chNom, this.longueur()-1));
};
/**
 * Fonction renvoyant true si ch est un nom valide pour une variable ou un calcul
 * @param {String} ch
 * @returns {Boolean}
 */
CListeObjets.prototype.validationNomVariableOuCalcul = function(ch) {
  var fini = false;
  while ((ch.length !== 1) && !fini) {
    if (ch.charAt(1) !== ' ') fini = true;
    else ch = ch.substring(1);
  }
  if (ch.length === 0) return false;
  var premierCar = ch.charAt(0);
  if (!Fonte.lettre(premierCar)) return false;
  else {
    var carPrecedent = premierCar;
    var valable = true;
    for (var i = 1; (i <= ch.length-1) && valable; i++)
    {
      var carEnCours = ch.charAt(i);
      // Cas d'une lettre
      if (Fonte.lettre(carEnCours))
      {
        if (Fonte.chiffre(carPrecedent) || Fonte.prime(carPrecedent))
          valable = false;
      }
      else
      if (Fonte.prime(carEnCours)) {
        if (Fonte.chiffre(carPrecedent) || Fonte.prime(carPrecedent))
          valable = false;
      }
      else {
        if (!Fonte.chiffre(carEnCours)) valable = false;
        carPrecedent = carEnCours;
      }
    }
    return valable;
  }
};
/**
 * Fonction enregistrant la liste dans un flus de données binaires.
 * @param {DataOutputStream} oups
 * @returns {undefined}
 */
CListeObjets.prototype.write = function(oups) {
  oups.writeInt(this.uniteAngle);
  oups.writeInt(this.col.length);
  for (var i = 0; i < this.col.length; i++) {
    oups.writeObject( this.get(i));
  }
  var indiceLongueurUnite;
  if (this.pointeurLongueurUnite === null) indiceLongueurUnite = -1;
  else indiceLongueurUnite = this.indexOf(this.pointeurLongueurUnite);
  oups.writeInt(indiceLongueurUnite);
  // Inutile pour l'applet
  var indiceMacroParDefaut;
  if (this.macroParDefaut === null) indiceMacroParDefaut = -1;
  else  indiceMacroParDefaut = this.indexOf(this.macroParDefaut);
  oups.writeInt(indiceMacroParDefaut);
  var indiceMacroDemarrage;
  if (this.macroDemarrage === null) indiceMacroDemarrage = -1;
  else indiceMacroDemarrage = this.indexOf(this.macroDemarrage);
  oups.writeInt(indiceMacroDemarrage);
};
// Pour le chargement des constructions
CListeObjets.prototype.readPourProtoDepuisFlux = function(inps) {
  var nombreObjets = inps.readInt();
  for (var i = 0; i < nombreObjets; i++) {
    var elb = inps.readObject(this);
    elb.index = i; // Rajouté version 4.8.0
    this.add(elb);
  }
};
/**
 * Fonction utilsiée pour enregistrer un prototype (construction) dans un flux de données bianires.
 * @param {DataOutputStream} oups
 * @returns {undefined}
 */
CListeObjets.prototype.writePourProtoDepuisFlux = function(oups) {
  oups.writeInt(this.col.length);
  for (var i = 0; i < this.col.length; i++) oups.writeObject( this.get(i));
};
/**
 * Fonction renvoyant true si chaine contient le nom d'une variable ou calcul
 * ou fonction réelle ou complexe définie par l'utilisateur.
 * L'élément excle est sauté dans la recherche.
 * @param {String} chaine
 * @param {Iteger} indiceMaxiDansListe : L'indice de recherche mai dans la liste.
 * @param {CElementBase} exclu : null ou l'élément exclu de la recherche.
 * @returns {Boolean}
 */
CListeObjets.prototype.egalNomValeurOuFonctionOuMesure = function(chaine, indiceMaxiDansListe, exclu) {
  var trouve = false;
  if (arguments.length <= 2) exclu = false;
  for (var i = 0; !trouve && (i <= indiceMaxiDansListe); i++) {
    var elb =  this.get(i);
    if (elb !== exclu) {
      // Modifié version 4.7.5
      if (elb.estDeNatureCalcul(Nat.or(NatCal.NTteValROuC, NatCal.NTteFoncR,
          NatCal.NTteFoncC, NatCal.NDerivee, NatCal.NTteSuiteRecR,
          NatCal.NTteSuiteRecC)) && !elb.estElementIntermediaire()) {
        if (elb.chaineEgaleANom(chaine)) trouve = true;
      }
    }
  }
  return trouve;
};
/**
 * Renvoie true si la syntaxe de chaineCalcul est correcte pour un calcul réel.
 * Si indiceMaxi est égal à -1 ou absent la recherche se fait jusqu'à la fin de la liste.
 * @param {String} chaineCalcul : La chaîne dont on analyse la syntaxe.
 * @param {Array} variable : un tableau contenant des noms de varaibel formelles
 * @param {Pointeur} indiceErreur : getValue() renvoie l'indice dans la
 * chaîne d'une éventuelle faute de syntaxe trouvée
 * @param {Integer} indiceMaxi
 * @returns {Boolean}
 */
CListeObjets.prototype.verifieSyntaxe = function(chaineCalcul, variable, indiceErreur, indiceMaxi) {
  const CalcR = require('../kernel/CalcR')
  if (arguments.length <= 3) indiceMaxi = this.longueur()-1;
  if (arguments.length <= 2) indiceErreur = new Pointeur(0);
  if (arguments.length === 1) variable = null;
  return CalcR.verifieSyntaxe(this, chaineCalcul, indiceErreur, indiceMaxi, variable);
};
/**
 * Renvoie true si la syntaxe de chaineCalcul est correcte pour un calcul complexe.
 * Si indiceMaxi est égal à -1 ou absent la recherche se fait jusqu'à la fin de la liste.
 * @param {String} chaineCalcul : La chaîne dont on analyse la syntaxe.
 * @param {Array} variable : un tableau contenant des noms de varaibel formelles
 * @param {Pointeur} indiceErreur : getValue() renvoie l'indice dans la
 * chaîne d'une éventuelle faute de syntaxe trouvée
 * @param {Integer} indiceMaxi
 * @returns {Boolean}
 */
CListeObjets.prototype.verifieSyntaxeComplexe = function(chaineCalcul, variable, indiceErreur, indiceMaxi) {
  const CalcC = require('../kernel/CalcC')
  if (arguments.length <= 3) indiceMaxi = this.longueur()-1;
  if (arguments.length <= 2) indiceErreur = new Pointeur(0);
  if (arguments.length === 1) variable = null;
  return CalcC.verifieSyntaxeComplexe(this, chaineCalcul, indiceErreur, indiceMaxi, variable);
};
/**
 * Fonction changeant la formule du calcul ou de la fonction (réelle ou complexe) de nom nomCalcul
 * La nouvelle formule est contenue dans la chaîne de caractères formule.
 * Renvoie true si la formule était valide et false sinon.
 * Créée pour être utilisé par un utilisateur externe
 * @param {String} nomCalcul
 * @param {String} formule
 * @returns {Boolean}
 */
CListeObjets.prototype.giveFormula2 = function(nomCalcul, formule) {
  if (typeof formule === "number") formule = String(formule);
  var variable = null;
  var indiceErreur = new Pointeur(0);
  var calcul = this.pointeurParNatureCalcul(NatCal.NTtCalcouFoncRouC, nomCalcul);
  if (calcul === null) return false;
  if (calcul.estDeNatureCalcul(NatCal.NTteFoncRouC)) variable = calcul.chaineVariable;
  var reel = calcul.estDeNatureCalcul(Nat.or(NatCal.NCalculReel,
    NatCal.NFonction, NatCal.NFoncPlusieursVar));
  if (reel ? this.verifieSyntaxe(formule, variable, indiceErreur, this.longueur-1) :
    this.verifieSyntaxeComplexe(formule, variable, indiceErreur, this.longueur-1)){
    calcul.chaineCalcul = formule;
    var len = formule.length-1;
    calcul.calcul = reel ? CalcR.ccb(formule, this, 0, len, variable) :
      CalcC.ccbComp(formule, this, 0, len, variable);
    return true;
  } else return false;
};
/**
 * Fonction renvoyant true si la chaine ch commence par le nom d'une fonction
 * prédéfinie (réelle ou complexe) suivi d'une parenthèse.
 * Si oui, longNom.getValue() renvoie la longueur du nom.
 * La recherche commence à l'indice indstart
 * @param {String} pChaine : La chaîne dans laquelle se fait la recherche.
 * @param {Integer} indstart
 * @param {Pointeur} longNom
 * @returns {Boolean}
 */
CListeObjets.prototype.commenceParNomFonctionPredefinieSuivieParOuvr = function(pChaine, indstart, longNom) {
  var ch = pChaine.substring(indstart).toLowerCase();
  var i;
  // On commence par les fonctions de quatre variables car integrale commence par int une autre fonction
  for (i = 0; i < Opef4v.nomsFoncs4Var.length; i++) {
    longNom.setValue(Opef4v.nomsFonctions4Var(i).length);
    if (ch.indexOf(Opef4v.nomsFonctions4Var(i).toLowerCase()+"(") === 0) return true;
  }
  for (i = 0; i < Opef.nomsFoncs.length; i++) {
    longNom.setValue(Opef.nomsFonctions(i).length);
    if (ch.indexOf(Opef.nomsFonctions(i).toLowerCase()+"(") === 0) return true;
  }
  for (i = 0; i < Opef2v.nomsFoncs2Var.length; i++) {
    longNom.setValue(Opef2v.nomsFonctions2Var(i).length);
    if (ch.indexOf(Opef2v.nomsFonctions2Var(i).toLowerCase()+"(") === 0) return true;
  }
  for (i = 0; i < Opef3v.nomsFoncs3Var.length; i++) {
    longNom.setValue(Opef3v.nomsFonctions3Var(i).length);
    if (ch.indexOf(Opef3v.nomsFonctions3Var(i).toLowerCase()+"(") === 0) return true;
  }
  for (i = 0; i < Opef5v.nomsFoncs5Var.length; i++) {
    longNom.setValue(Opef5v.nomsFonctions5Var(i).length);
    if (ch.indexOf(Opef5v.nomsFonctions5Var(i).toLowerCase()+"(") === 0) return true;
  }
  // Inutile de regarder les noms des fonctions complexes de plus de deux variables car c'est le même que les fonctions réelles
  for (i = 0; i < Opef.nomsFoncsComplexes.length; i++) {
    longNom.setValue(Opef.nomsFonctionsComplexes(i).length);
    if (ch.indexOf(Opef.nomsFonctionsComplexes(i).toLowerCase()+"(") === 0)  return true;
  }
  return false;
};
/**
 * Fonction renvoyant true si la chaine ch commence par le nom d'une fonction
 * utilisateur (réelle ou complexe) suivi d'une parenthèse.
 * Si oui, longNom.getValue() renvoie la longueur du nom.
 * La recherche commence à l'indice indstart
 * @param {String} pChaine : La chaîne dans laquelle se fait la recherche.
 * @param {Integer} indstart
 * @param {Pointeur} longNom
 * @returns {Boolean}
 */
CListeObjets.prototype.commenceParNomFonctionUtilisateurSuivieParOuvr = function(pChaine, indstart, longNom) {
  var i, elb, nom;
  var ch = pChaine.substring(indstart).toLowerCase();
  for (i = 0; i < this.longueur(); i++){
    elb = this.get(i);
    if (!elb.estElementIntermediaire()
        && elb.estDeNatureCalcul(Nat.or(NatCal.NTteFoncR, NatCal.NDerivee,
          NatCal.NSuiteRecurrenteReelle, NatCal.NTteFoncC, NatCal.NSuiteRecurrenteComplexe))) {
      // ptf = (CCalculAncetre) elb;
      nom = elb.getNom();
      if (ch.indexOf(nom + "(") === 0) {
        longNom.setValue(nom.length);
        return true;
      }
    }
  }
  return false;
};
/**
 * Fonction assumant que la chaîne ch n'utilise que des calculs ou fonctions utilisateurs
 * dont le nom ne comporte qu'une lettre suivie éventuellement de chiffres ou de ' ou de ".
 * Elle rajoute les signes de multiplication sous-entendus.
 * @param {String} ch : La chaine contenant la formule.
 * @returns {String}
 */
CListeObjets.prototype.traiteSignesMult = function(ch) {
  if (ch.length === 0) return ch;
  var i, car;
  var stb = "";
  var lon = new Pointeur(0);
  var carprecedent = '(';
  for (i = 0; i < ch.length; i ++) {
    car = ch.charAt(i);
    if (Fonte.chiffreOuPointDecimal(car) || (car === ')') || (car === '+') || (car === '-')
        || (car === '*') || (car === '/') || (car === '^') || (car === '\'') || (car === '\"') || (car === '²')) {
      carprecedent = car;
      stb = stb + car;
    }
    else {
      if (ch.indexOf("pi",i) === i) {
        if (Fonte.chiffreOuPointDecimal(carprecedent) || Fonte.lettreOuPrime(carprecedent)
          || (carprecedent === ')')) stb = stb + ("*pi");
        else stb = stb + ("pi");
        carprecedent = ')';
        i++;
      }
      else {
        if (this.commenceParNomFonctionPredefinieSuivieParOuvr(ch, i, lon)) {
          if (Fonte.chiffreOuPointDecimal(carprecedent) || Fonte.lettreOuPrime(carprecedent)
            || (carprecedent === ')')) stb = stb + "*" + ch.substring(i, i+lon.getValue()+1);
          else stb = stb + ch.substring(i, i+lon.getValue()+1);
          i+= lon.getValue();
          carprecedent = '(';
        }
        else {
          if (this.commenceParNomFonctionUtilisateurSuivieParOuvr(ch, i, lon)) {
            if (Fonte.chiffreOuPointDecimal(carprecedent) || Fonte.lettreOuPrime(carprecedent)
              || (carprecedent === ')')) stb = stb + "*" + ch.substring(i, i+lon.getValue()+1);
            else stb = stb + ch.substring(i, i+lon.getValue()+1);
            i+= lon.getValue();
            carprecedent = '(';
          }
          else {
            // Si lettre suivie d'une autre lettre
            if (Fonte.lettreOuPrime(carprecedent) && Fonte.lettre(car)) stb = stb + '*';
            // Si chiffre suivi d'une lettre
            else if (Fonte.chiffreOuCarre(carprecedent) && Fonte.lettre(car)) stb = stb + '*';
            // Si chiffre ou lettre suivi d'une parenthèse on rajoute un signe de multiplication
            else if ((Fonte.chiffreOuCarre(carprecedent) || Fonte.lettreOuPrime(carprecedent))
              && (car === '(')) stb = stb + '*';
            // Si parenthèse fermante suivie d'un chiffre ou une lettre ou une parenthèse ouvrante on rajoute un signe de multiplication
            else if ((carprecedent === ')') && (Fonte.lettre(car) || Fonte.chiffre(car)
              || (car === '('))) stb = stb + '*';
            stb = stb + car;
            carprecedent = car;
          }
        }
      }
    }
  }
  return stb;
};
// Spécial JavaScript : Affichage et aout dans le DOM des objets de la liste
// Attention : paramètre ideb supplémentaire par rapport à la version Java
/**
 * Spécial JavaScript : Affichage et ajout dans le DOM des svg elements qui représentent
 * les objets de la liste.
 * Attention : paramètre ideb supplémentaire par rapport à la version Java
 * @param {Integer} ideb : L'indice du premier carcatère à afficher.
 * @param {svg} svg : Le svg dans lequel se fait l'affichage de la figure.
 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
 * @param {mtg32.Color} couleurFond : La couleur de fonc de la figure.
 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
 * (qui se règle par un curseur sous la palette de couleurs dans MathGraph32).
 * @returns {undefined}
 */
CListeObjets.prototype.afficheTout = function(ideb, svg, masquage, couleurFond, transparence){
  for (var i = ideb; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.estDeNature(NatObj.NTtObj) && !elb.estElementIntermediaire())
      elb.creeAffichage(svg,masquage,couleurFond,transparence);
  }
};

/**
 * Spécial JavaScript : fonction mettant à jour certains éléments associés à des éléments du DOM
 * @param {svg} svg : Le svg qui contient la figure.
 * @param {mtg32.Color} couleurFond
 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
 * @returns {undefined}
 */
CListeObjets.prototype.update = function(svg, couleurFond, transparence, masquage) {
  this.setReady4MathJaxUpdate();
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    MathJax.Hub.Queue([this.callBack,elb,svg,couleurFond,transparence,masquage]);
  }
};
/**
 * Spécial JavaScript : fonction mettant à jour certains éléments associés à des éléments du DOM
 * @param {CElementBase} : Ne seront mis à jours que les éléments dépendant de elb
 * @param {svg} svg : Le svg qui contient la figure.
 * @param {mtg32.Color} couleurFond
 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
 * @returns {undefined}
 */

CListeObjets.prototype.updateDependants = function(el, svg, couleurFond, transparence, masquage) {
  this.setDependantsReady4MathJaxUpdate(el);
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.dependDe(el)) MathJax.Hub.Queue([this.callBack,elb,svg,couleurFond,transparence,masquage]);
  }
};

/**
 * Fonction de callBack appelée par certians objets après u'ils aient été traités
 * par MathJax (les affichages de LaTeX)
 * @param {CElementGraphique} elb : L'objet dont l'affichage doit être remis à jour.
 * @param {svg} svg : Le svg qui contient la figure.
 * @param {mtg32.Color} couleurFond : La couleur de fond de la figure.
 * @param {Number} transparence : Définit le coefficient de transparence utilisé pour les surfaces
 * (qui se règle par un curseur sous la palette de couleurs dans MathGraph32).
 * @param {Boolean} masquage : true si les éléments masqués ne sont pas affichés
 * @returns {undefined}
 */
CListeObjets.prototype.callBack = function(elb,svg, couleurFond, transparence, masquage) {
  var hasg,gname;
  if (elb.estDeNature(NatObj.NTtObj)) {
     // Il faut tester que la liste propiétaire de l'élément n'est pas null car
     // si des objets visuels sont actifs et qu'on choisit, avant de finir d'utiliser l'outil ,
     // de faire un annuler-refaire, elg n'a plus d'implémentation graphique dans le SVG de la figure
     if (!elb.estElementIntermediaire() && (elb.listeProprietaire!== null)) {
       hasg = elb.hasg(masquage);
       if (elb.hasgElement) { // Si l'objet avait une implémentation graphique dans le svg
         if (hasg) {
           elb.update(svg, couleurFond, transparence);
           elb.updateTrace(svg, couleurFond, transparence); // Pour les points marqués pour la trace
           if (elb.estDeNature(NatObj.NObjNommable) && (elb.nom !== "")
             && !elb.nomMasque) elb.updateNamePosition();
           // elb.hasgElement = true; // Supprimé version mtgApp. Inutile
         }
         else {
           var newg = kernel.cens("g"); // Un g vide
           svg.replaceChild(newg, elb.g);
           newg.setAttribute("id", elb.id);
           elb.g = newg;
           elb.hasgElement = false;
           if (elb.estDeNature(NatObj.NObjNommable) && (elb.nom !== "")
             && !elb.nomMasque) {
             gname = kernel.cens("g");
             svg.replaceChild(gname, elb.gname);
             elb.gname = gname;
           }
         }
       }
       else {
         if (hasg && !(masquage && elb.masque)) {
           var g = elb.createg(svg, couleurFond, transparence);
           svg.replaceChild(g, elb.g);
           g.setAttribute("id", elb.id);
           elb.g = g;
           elb.hasgElement = true;
           if (elb.estDeNature(NatObj.NObjNommable) && (elb.nom !== "")
             && !elb.nomMasque) elb.updateName(svg, masquage);
           elb.updateTrace(svg, couleurFond, transparence); // Pour les points marqués pour la trace
         }
       }
     }
   }
};
/**
 * Fonction renvoyant true si les points pt1 et pt2 sont par définition sur une droite
 * parallèle à droite.
 * @param {CPt} pt1 : Le premier point testé.
 * @param {CPt} pt2 : Le secondd point testé.
 * @param {CDroiteAncetre} droite
 * @returns {Boolean}
 */
CListeObjets.prototype.sontParDefinitionSurParallele = function(pt1, pt2, droite) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.estDeNature(NatObj.NTteDroiteSaufVect)) {
      if (pt1.appartientDroiteParDefinition(elb) && pt2.appartientDroiteParDefinition(elb)
          && (elb.estParalleleParDefinition(droite) || droite.estParalleleParDefinition(elb))) return true;
    }
  }
  return false;
};
/**
 * Fonction utilisé dans les listes d'objets.
 * Recrée les liste d'objets dans les lieux d'objest dépendant
 * @param {mtg32.CLeiuObjetAncetre} lieu
 * @returns {undefined}
 */
CListeObjets.prototype.recreeListesCopiesLieuxObjetsDependantDe = function(lieu) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NLieuObjet) && (elb !== lieu) && elb.dependDe(lieu)) {
      elb.recreeListeCopieObjets();
    }
  }
};
/**
 * Fonction mettant à jour tous les éléments de la liste qui ont une fonction
 * metAJour redéfinie.
 * Utilisée pour mettre à jour par exemple les lieux de points et lieux d'objets
 * ou certaines macros.
 * @returns {undefined}
 */
CListeObjets.prototype.metAJour = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    el.metAJour();
  }
};
/**
 * Fonction mettant à jour les objets de la figure qui nécessitent de l'être
 * et qui dépendent de elb à l'exclusion des éditeurs de formule.
 * @param {type} elb
 * @returns {undefined}
 */
CListeObjets.prototype.metAJourObjetsDependantDeSaufEditeursFormule = function(elb) {
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    if ((!el.estDeNature(NatObj.NEditeurFormule)) && el.dependDe(elb))
      el.metAJour();
  }
};
/**
 * Fonction renvoyant un pointeur sur l'objet calcul de nature calcul nature
 * et dont le nom est nom. Renvoie null la recherche est infructueuse.
 * @param {String} nom : Le nom du calcul cherché
 * @param {mtg32.Nature} nature : la nature de calcul recherchée
 * @returns {CCalculAncetre}
 */
CListeObjets.prototype.pointeurObjetCalcul = function(nom, nature) {
  var  indiceMaxi = this.longueur() - 1;
  var elb = null;
  for (var i = 0; i <= indiceMaxi; i++) {
    elb = this.get(i);
    if (elb.estDeNatureCalcul(nature))
      if (elb.nomCalcul === nom) return elb;
  }
  return null;
};
/**
 * Fonction conçue pour être utilisée de façon externe.
 * Renvoie la valeur actuelle du calcul réel nommé nomCalcul.
 * Renvoie -1 si le calcul n'existe pas.
 * Utilisé prinipalement dans les exercices de calcul de j3p.
 * @param {String} nomCalcul : Le nom du calcul dont on demande la valeur.
 * @returns {Number}
 */
CListeObjets.prototype.valueOf = function(nomCalcul) {
  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NTtCalcRNommeSaufConst);
  if (calcul === null) return -1;
  else {
    if (!calcul.existe) return -1;
    else return calcul.rendValeur();
 }
};
/**
 * Fonction conçue pour être utilisée de façon externe.
 * Renvoie la formule en ligne (avec des *) du calcul ou de la fonction nommé nomCalcul
 * @param {String} nomCalcul
 * @returns {String}
 */
CListeObjets.prototype.getFormula = function(nomCalcul) {
  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NCalcouFoncParFormule);
  if (calcul === null) return -1;
  else {
    if (!calcul.existe) return "";
    // Remanié version 4.9.9.3
    // else return calcul.chaineCalcul;
    var varFor = calcul.variableFormelle();
    return calcul.calcul.chaineCalcul(varFor);
 }
};
/**
 * Fonction renvoyant la formule LaTeX représentant le calcul ou la fonction
 * dont le nom est nomCalcul.
 * @param {String} nomCalcul : Le nom du calcul dont on veut la formule
 * @returns {String}
 */
CListeObjets.prototype.getLatexFormula = function(nomCalcul) {
  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NCalcouFoncParFormule);
  if (calcul === null) return "";
  else {
    var varFor = calcul.variableFormelle();
    return calcul.calcul.chaineLatexSansPar(varFor);
 }
};
// Ajout version 4.9.7
/**
 * Fonction utilisée dans j3p.
 * Renvoie le code LaTeX contenu dans l'affichage LaTeX ne rang ind dans la lsite
 * parmis les affichages LaTeX de la liste.
 * @param {Integer} ind : L'indice de l'affichage LaTeX parmis tous les affichages LaTeX.
 * @returns {String}
 */
CListeObjets.prototype.getLatexCode = function(ind) {
  var j = 0;
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    if (el.getNature() === NatObj.NLatex) {
      if (j === ind) return el.chaineLatex;
      j++;
    }
  }
  return "";
};
/**
 * Fonction conçue pour être utilisée de façon externe.
 * Renvoie la formule LaTeX normalisée représentant le calcul ou la fonction
 * une fois que les valeurs utilsées dans la formule ont été remplacées
 * et que les simplifications de normalisation ont été effectuées :
 * Suppression des additions de 0, ddes multiplications ou divisions par 1.
 * @param {String} nomCalcul : Le calcul ou la fonction réelle ou complexe
 * dont on demande la formule;
 * @returns {String}
 */
CListeObjets.prototype.getForSimp = function(nomCalcul) {
  var calcul = this.pointeurObjetCalcul(nomCalcul, NatCal.NCalcouFoncParFormule);
  if (calcul === null) return "";
  else {
    var varFor = calcul.variableFormelle();
    return calcul.calcul.calculAvecValeursRemplacees().calculNormalise(true, false, false).chaineLatexSansPar(varFor);
 }
};
/**
 * Fonction exécutant la macro dont l'intitulé ets nameMacro.
 * @param {type} nameMacro
 * @returns {Boolean}
 */
CListeObjets.prototype.executeMacro = function(nameMacro) {
  var macroAExecuter = this.pointeurMacro(nameMacro);
  if (macroAExecuter === null) return false;
  // Ajout version 5.0
  macroAExecuter.setMacroLanceuse(null);
  //
  if (macroAExecuter.executionPossible()) {
    this.macroEnCours = macroAExecuter;
    macroAExecuter.initialise();
    var svg = document.getElementById(this.id);
    var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
    var doc = this.documentProprietaire;
    macroAExecuter.execute(svg, dimf, doc.couleurFond, doc.opacity, true);
    return true;
  }
  else return false;
};
/**
 * Fonction demandant la validation de tous les éditeurs de formule de la figure
 * Si la formule qu'ils contiennent est incorrecte ils se trouvent encadrés de rouge.
 * Renvoie true uniquement si aucun éditeur de formule ne contient de faute de syntaxe.
 * @returns {Boolean}
 */
CListeObjets.prototype.fieldsValidation = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.getNature() === NatObj.NEditeurFormule) {
      if (!elb.validation(false)) return false;
    }
  }
  return true;
};
/**
 * Fonction renvoyant true si le contenu du permier éditeur de formule
 * ssocié au calcul nomCalcul est correct au point syntaxique et non vide
 * @param {String} nomCalcul
 * @returns {Boolean}
 */
CListeObjets.prototype.fieldValidation = function(nomCalcul) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NEditeurFormule) && (elb.calculAssocie.nomCalcul === nomCalcul)) {
      return elb.validation(false) && (elb.editeur.value.length !== 0);
    }
  }
  return false;
};
// Fonction renvoyant le contenu du premier éditeur de formule asssocié au calcul nomCalcul
/**
 * Fonction renvoyant le contenu du premier éditeur de formule asssocié au calcul nomCalcul
 * @param {String} nomCalcul
 * @returns {String}
 */
CListeObjets.prototype.getFieldValue = function(nomCalcul) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NEditeurFormule) && (elb.calculAssocie.nomCalcul === nomCalcul))
      return elb.editeur.value;
  }
  return "error";
};
/**
 * Fonction donnant le focus au premier éditeur de formule qui ne contient rien.
 * @returns {undefined}
 */
CListeObjets.prototype.activateFirstEmptyField = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.getNature() === NatObj.NEditeurFormule) {
      if (elb.editeur.value.length === 0) {
        elb.editeur.focus();
        break;
      }
    }
  }
};
/**
 * Fonction activant le premier éditeur de formule contenant une
 * formule qui n'est pas correcte sur le plan syntaxique.
 * @returns {undefined}
 */
CListeObjets.prototype.activateFirstInvalidField = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.getNature() === NatObj.NEditeurFormule) {
      if (!elb.validation(false)) {
        elb.editeur.focus();
        break;
      }
    }
  }
};
/**
 * Fonction activant le premier éditeur de formule vide ou contenant une
 * formule qui n'est pas correcte sur le plan syntaxique.
 * @returns {undefined}
 */

CListeObjets.prototype.activateFirstInvalidOrEmptyField = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.getNature() === NatObj.NEditeurFormule) {
      if ((elb.editeur.value.length === 0) || !elb.validation(false)) {
        elb.editeur.focus();
        break;
      }
    }
  }
};
/**
 * Fonctiondonnant le focus au premier éditeur de formule associé au calcul
 * ou à la fonction nommé nomCalcul.
 * @param {String} nomCalcul
 * @returns {undefined}
 */
CListeObjets.prototype.activateField = function(nomCalcul) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NEditeurFormule) && (elb.calculAssocie.nomCalcul === nomCalcul)) {
      elb.editeur.focus();
      break;
    }
  }
};
// Fonction vidant tous les champs d'édition
/**
 * Fonction vidant tous les éditeurs de formule de la figure.
 * @returns {undefined}
 */
CListeObjets.prototype.setEditorsEmpty = function() {
  var svg = document.getElementById(this.id);
  var dimf = new Dimf(parseInt(svg.getAttribute("width")), parseInt(svg.getAttribute("height")));
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.getNature() === NatObj.NEditeurFormule) {
        elb.editeur.value = "";
        if (elb.affichageFormule) {
          elb.latex.chaineCommentaire = elb.preCodeLaTeX;
          elb.latex.positionne(false, dimf);
          elb.latex.setReady4MathJax();
          MathJax.Hub.Queue([elb.callBack,elb,svg]);
        }
    }
  }
};
/**
 * Fonction associant au premier éditeur de formule associé à calcul ou une fonction
 * nommé nomCalcul une fonction de callBack qui sera appelée quand l'utilisateur
 * valide par OK le contenu de l'éditeur.
 * Utilisé dans j3p ou d'autres modules externes.
 * @param {String} nomCalcul
 * @param {function} f
 * @returns {undefined}
 */
CListeObjets.prototype.setEditorCallBackOK = function(nomCalcul, f) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NEditeurFormule) && (elb.calculAssocie.nomCalcul === nomCalcul)) {
      elb.callBackOK = f;
      break;
    }
  }
};
// Ajout version 4.9.3
/**
 * Fonctionmettant dans le premier éditeur de formule associé à nomCalcul
 * la chaine st.
 * @param {String} nomCalcul
 * @param {String} st
 * @returns {undefined}
 */
CListeObjets.prototype.setEditorValue = function(nomCalcul, st) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NEditeurFormule) && (elb.calculAssocie.nomCalcul === nomCalcul)) {
      elb.setEditorValue(st);
      break;
    }
  }
};
//
// Ajoute au tableau des traces un élément graphique
/**
 * Spécial JavaScript : Ajoute au tableau des traces un élément graphique
 * @param {svg.Element} tr : le svg element qu'on ajoute
 * @returns {undefined}
 */
CListeObjets.prototype.addTrace = function(tr){
  var gt = this.documentProprietaire.gTraces;
  if (this.nbTraces < CListeObjets.nbMaxiTraces) {
    // this.traces.push(tr); // Supprimé version 4.9.2
    gt.appendChild(tr);
    this.nbTraces++;
  }
  else {
    // gt.removeChild(this.traces.shift()); // Modifié version 4.9.2
    gt.removeChild(gt.childNodes[0]);
    // this.traces.push(tr); // Supprimé verison 4.9.2
    gt.appendChild(tr);
  }
};
/**
 * Ajoute au tableau des traces les éléments graphiques d'une liste d'objets
 * @param {type} list
 * @returns {undefined}
 */
CListeObjets.prototype.addTraces = function(list){
  var gt = this.documentProprietaire.gTraces;
  for (var i = 0; i < list.longueur(); i++) {
    var el = list.get(i);
    if (el.existe && el.hasg(false)) { // false pour que même les éléments masqués laissent une trace
      var g = el.createg();
      if (el !== null) {
        if (this.nbTraces < CListeObjets.nbMaxiTraces) {
          // this.traces.push(g); // Supprimé version 4.9.2
          gt.appendChild(g);
          this.nbTraces++;
        }
        else {
          // gt.removeChild(this.traces.shift());  // Modifié version 4.9.2
          gt.removeChild(gt.childNodes[0]);
          // this.traces.push(g); // Supprimé version 4.9.2
          gt.appendChild(g);
        }
      }
    }
  }
};
/**
 * Fonction retirant toutes les traces de la figure.
 * @returns {undefined}
 */
CListeObjets.prototype.deleteTraces = function() {
  var gt = this.documentProprietaire.gTraces;
  //Modifié version 4.9.2. Inutile de mémoriser les traces dans un tableau
  // while (this.traces.length != 0) gt.removeChild(this.traces.shift());
  while (gt.childNodes.length !== 0) gt.removeChild(gt.childNodes[0]);
  this.nbTraces = 0;
};
/**
 * Fonction initialisant les traces de la figure si le mode trace
 * de la figure est activé.
 * @returns {undefined}
 */
CListeObjets.prototype.initialiseTraces = function() {
  if (!this.documentProprietaire.modeTraceActive) this.deleteTraces();
};
/**
 * Spécial version JavaScript : les objets qui créent un composant ajouté dans le DOM
 * dans le div parent du SVG détruisent ces objets
 *
 */
/**
 * Fonction demandant aux éléments de la figure qui ont créé un objet dans le DOM
 * (à savoit les éditeurs de formules) de détruire ces composants.
 * @param {svg} svg : Le svg qui contient la figure.
 * @returns {undefined}
 */
CListeObjets.prototype.deleteComponents = function(svg) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    elb.deleteComponent(svg); // Modifié version mtgApp
  }
};

CListeObjets.prototype.createComponents = function(svg) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    elb.createComponent(svg); // Modifié version mtgApp
  }
};

/**
 * Fonction renvoyant true si la liste contient un point ou un droite
 * autre que element ayant pour nom st.
 * @param {CElementBase} element
 * @param {String} st : Le nom recherché.
 * @param {Boolean} intermPermis : Si true on rehcerhce aussi dans les objets intermédiaires de constructions
 * @returns {Boolean}
 */
CListeObjets.prototype.existePointOuDroiteMemeNom = function(element, st, intermPermis) {
  var interm = arguments.length <= 2 ? false : intermPermis
  var i,elb;
  for (i = 0; i < this.longueur(); i++) {
    elb = this.get(i);
    if ((interm || !elb.estElementIntermediaire()) && elb.estDeNature(Nat.or(NatObj.NTtPoint,NatObj.NDroite))) {
      if (elb !== element) {
        if (elb.nom === st) return true;
      }
    }
  }
  return false;
};
// Ajout version 4.8
/**
 * Fonction renvoyant true si la liste contient une focntion réelle ou complexe
 * ou un paramètre de fonction à une variable égal à chaine.
 * @param {type} chaine
 * @returns {Boolean}
 */
CListeObjets.prototype.egalNomParametreFonction = function(chaine) {
  for (var i = 0; i < this.longeur; i++) {
    var elb = this.get(i);
    if (elb.getNatureCalcul() === NatCal.NFonction) {
      if (chaine.toLowerCase() === elb.chaineVariable) return true;
    }
    else {
      if (elb.getNatureCalcul() === NatCal.NFonctionComplexe) {
        if (chaine.toLowerCase() === elb.chaineVariable) return true;
      }
    }
  }
  return false;
};

// Ajout version 4.8
/**
 * Fonction générant un nom de calcul commençant par la chaîne ch
 * Si bchiffreImpose est résent et true, on impose que ch soit suivie d'un chiffre à partir de 1
 * @param ch
 * @param bchiffreImpose
 * @returns {string}
 */
CListeObjets.prototype.genereNomPourCalcul = function(ch, bchiffreImpose) {
  const CCbGlob = require('../kernel/CCbGlob')
  var b = arguments.length === 2 ? bchiffreImpose : false;
  var i, nomGenere;
  // Modifié version 4.8
  for (i = b ? 1 : 0;;i++) {
    nomGenere = ch;
    if (i !== 0) nomGenere += i;
    if (!this.egalNomValeurOuFonctionOuMesure(nomGenere, this.longueur() - 1, null)
        && !this.egalNomParametreFonction(nomGenere)
        && !CCbGlob.egalNomFonctionReelleOuComplexePredefinie(nomGenere))
      return nomGenere.toString();
  }
  // return "";
};

/**
 * Spécial version mtgApp
 * Remplace dans les CCOmmentaire et CLatex utilisant des affichages dynamiques ancienNom par nouveauNom
 * @param ancienNom
 * @param nouveauNom
 */
CListeObjets.prototype.remplaceNomValeurDynamiqueDansCommentairesOuLatex = function(ancienNom, nouveauNom) {
  var i,elb;
  for (i = 0; i < this.longueur(); i++) {
    elb = this.get(i);
    if (elb.estDeNature(NatObj.NComouLatex)) elb.remplaceNomValeurDynamique(ancienNom, nouveauNom);
  }
};
/**
 * Fonction mettant à jour tous les éléments de la liste er les positionant
 * @param infoRandom
 * @param dimfen : Dimf
 */
CListeObjets.prototype.metAJourEtPositionne = function(infoRandom, dimfen) {
  var i,el;
  for (i = 0; i < this.longueur(); i++) {
    el = this.get(i);
    el.metAJour();
    el.positionne(infoRandom, dimfen);
  }
};

// Ajout version 4.8
/**
 * Fonction reconstruisant les chaînes de calcul de tous les calculs ou
 * fonctions utilisateur.
 * @returns {undefined}
 */
CListeObjets.prototype.reconstruitChainesCalcul = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.estDeNatureCalcul(NatCal.NCalcOuFoncNonConstante) )
      elb.reconstruitChaineCalcul();
  }
};
/**
 * Fonction renvoyant l'élément final de construction d'indice ind de la liste.
 * La recherche se fait à partir de inddeb.
 * Utilisé dans le constructions itératives.
 * @param {Integer} inddeb
 * @param {Integer} ind
 * @returns {CElementBase}
 */
CListeObjets.prototype.getFinal = function(inddeb, ind) {
  var el = null;
  var i = inddeb;
  var j = -1;
  while (j !== ind) {
    el = this.get(i);
    if (el.estElementFinal) {
      if (el.estDeNature(NatObj.NTtObj) || !el.estDeNatureCalcul(NatCal.NAucunCalcul)) j++;
    }
    i++;
  }
  return el;
};
/**
 * Fonction affectant à chaque élément de la liste son indice dans la liste.
 * @returns {undefined}
 */
CListeObjets.prototype.updateIndexes = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    // Attention : Les surfaces utilisant un quadrillage utilsiennt un pattern qui dépend de l'index de l'élément
    el.index = i;
    if (el.estDeNature(NatObj.NSurface)) {
      if (el.pattern !== null) el.pattern.childNodes[0].setAttribute("id", i + "mtg32pattern");
    }
  }
};

// Ajout version 4.9.2
/**
 * Fonction demandant à chaque objet pour lequel c'est nécéssaire de se préparer
 * pour le traitement par MathJax qui sera fait via une fonction de callback.
 * @param bMemeMasques : Si true et présent, appelé même quand l'objet est masqué (sert pour la boîte de dialogue de protoccole)
 * @param bMemeIntermediaires : Si true et présent appeké aussi pour les pobjets intermédiaires.
 * @returns {undefined}
 */
CListeObjets.prototype.setReady4MathJax = function(bMemeMasques, bMemeIntermediaires) {
  var memeMasques = arguments.length === 0 ? false : bMemeMasques;
  var memeIntermediaires = arguments === 2 ? bMemeIntermediaires : false;
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    if (el.existe && (!el.estElementIntermediaire() || memeIntermediaires)) el.setReady4MathJax(memeMasques);
  }
};
/**
 * Fonction demandant à chaque objet pour lequel c'est nécéssaire de se préparer
 * pour le traitement par MathJax qui sera fait via une fonction de callback.
 * Appelée quand on met à jour l'affichage de la figure.
 * @returns {undefined}
 */
CListeObjets.prototype.setReady4MathJaxUpdate = function() {
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    if (el.existe && !el.estElementIntermediaire()) el.setReady4MathJaxUpdate();
  }
};
/**
 * Fonction demandant à chaque objet dépendant de elb pour lequel c'est nécéssaire de se préparer
 * pour le traitement par MathJax qui sera fait via une fonction de callback.
 * Appelée quand on met à jour l'affichage de la figure.
 * @param{CElementBase}elb
 * @returns {undefined}
 */
CListeObjets.prototype.setDependantsReady4MathJaxUpdate = function(elb) {
  for (var i = 0; i < this.longueur(); i++) {
    var el = this.get(i);
    if (el.existe && !el.estElementIntermediaire() && el.dependDe(elb)) el.setReady4MathJaxUpdate();
  }
};

/**
 * Fonction zoomant a figure sur le point de coordonnées (xcnetr,ycentre)
 * avec le rapport rapport.
 * @param {Float} xcentre
 * @param {Float} ycentre
 * @param {Float} rapport
 * @returns {undefined}
 */
CListeObjets.prototype.zoom = function(xcentre,ycentre,rapport) {
  var i,origineUnite = null;
  if (this.pointeurLongueurUnite !== null) {
    var pt1 = this.pointeurLongueurUnite.point1;
    if (pt1.getNature() === NatObj.NPointBase) origineUnite = pt1;
  }
  for (i=0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if ((elb.getNature() === NatObj.NPointBase) && (elb !== origineUnite)) {
      if (elb.estLibre()) elb.zoom(xcentre, ycentre, rapport);
    }
    else {
      if (elb.getNature() === NatObj.NDroite) {
        if (elb.className === "CDroiteDirectionFixe") {
          if (elb.impProto !== null) {
            if (!elb.impProto.nomProto === "MathGraph32 Cursor") elb.zoom(rapport);
          }
          else elb.zoom(rapport);
        }
      }
    }
  }
};
/**
 * Fonction recalculant tous les éléments de type calcul de la figure
 * y compris les calculs de dérivées et lles test d'équivalence de formule
 * et les test de factorisation.
 * @param {type} infoRandom
 * @returns {undefined}
 */
CListeObjets.prototype.calculateNG = function(infoRandom) {
  var dimfen = new Dimf(600,600);
  this.positionneFullNG(infoRandom, dimfen);
};

CListeObjets.prototype.existeCalculOuVariableOuFonctionOuParametreNomCommencantPar = function(st,indFin) {
  var i,elb;
  for (i = 0; i <= indFin; i++) {
    elb = this.get(i);
    if (elb.estDeNatureCalcul(NatCal.NTteValROuC) && !elb.estElementIntermediaire()) {
      if (elb.nomCommencePar(st)) return true;
    }
  }
  return false;
};
/**
 * Fonction renvoyant true si la liste contient un point ou une droite dotn le nom
 * commence par st.
 * La recherche se fait jusqu'à l'indice indfin.
 * @param {String} st
 * @param {Integer} indFin
 * @returns {Boolean}
 */
CListeObjets.prototype.existePointOuDroiteNomCommencantPar = function(st,indFin) {
  var i,elb;
  for (i = 0; i < indFin; i++) {
    elb = this.get(i);
    if (! elb.estElementIntermediaire() && (elb.estDeNature(Nat.or(NatObj.NTtPoint,NatObj.NDroite)))) {
      if (elb.nom.length !== 0) {
        if (elb.nom.indexOf(st) === 0) return true;
      }
    }
  }
  return false;
};
/**
 * Fonction générant un nom de Calcul ou fonction libre commençant par debNom.
 * La recherche de noms existants s'arrête à indfin.
 * @param {Integer} debNom
 * @param {Integer} indFin
 * @returns {String}
 */
CListeObjets.prototype.genereDebutNomPourCalcul = function(debNom, indFin) {
  var i,j;
  if (!this.existeCalculOuVariableOuFonctionOuParametreNomCommencantPar(debNom, indFin)) return debNom;
  var ch = "abcdefghijklmnopqrstuvwxyz";
  var nomGenere = debNom;
  // Modifié version 4.8
  for (i = 0;; i++) {
    for (j = 0; j < ch.length; j++) {
      nomGenere = nomGenere.substring(0,debNom.length);
      nomGenere += ch.charAt(j);
      if (i !== 0)
        nomGenere+= i;
      if (!this.existeCalculOuVariableOuFonctionOuParametreNomCommencantPar(nomGenere.toString(), indFin))
        return nomGenere;
    }
  }
};
/**
 * Fonction générant un nom de point libre commençant par debNom.
 * La recherche de noms existants s'arrête à indfin.
 * @param {type} indFin
 * @returns {String}
 */
CListeObjets.prototype.genereDebutNomPourPoint = function(indFin) {
  var i,j,nomGenere;
  var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  // Modifié version 4.8
  for (i = 0;; i++) {
    for (j = 0; j < ch.length; j++) {
      nomGenere = ch.charAt(j);
      if (i !== 0)
        nomGenere += i;
      if (!this.existePointOuDroiteNomCommencantPar(nomGenere, indFin))
        return nomGenere;
    }
  }
};
/**
 * Fonction utilisée dans les implémentations récursiives de constructions.
 * @param {Integer} inddeb
 * @param {CPrototype} proto
 * @returns {undefined}
 */
CListeObjets.prototype.traiteImplementationsProtoSuccessivesRecur = function(inddeb, proto) {
  var i,j,ptgen,elb,nomCalcul,nomPoint,nomp,nomc,k,elg2,oldName,newName,e,nomGen;
  var lon = this.longueur();
  var type = Nat.or(NatObj.NTtPoint,NatObj.NDroite,NatObj.NDroiteClone);
  // On commence par renommer les points ou droites qui sont utilisés comme sources qui sont nommés dans le prototype
  for (i = 0; i < proto.nbObjSources; i++) {
    ptgen = proto.get(i);
    elb = ptgen.elementAssocie;
    if (elb.estDeNature(type)) {
      nomGen = ptgen.nom;
      // On regarde si l'élément correspondant était nommé.
      if ((nomGen.length !== 0) && (elb.rendNom().length === 0)) {
        elb.donneNom(this.genereDebutNomPourPoint(inddeb-1));
      }
    }
  }
  nomCalcul = this.genereDebutNomPourCalcul("", inddeb - 1);
  nomPoint = this.genereDebutNomPourPoint(inddeb - 1);
  nomp = 1;
  // int nomc = 1; // Modifié version 4.9.9
  nomc = 0;
  k = 0;
  for (i = inddeb+1; i < lon; i++) {
    elb = this.get(i);
    if (elb.estDeNature(NatObj.NImplementationProto))
      k = -1;
    else {
      if (elb.estDeNature(type)) {
        elg2 = proto.get(proto.nbObjSources + k);
        if (!elg2.rendNom().length===0) elb.donneNom(nomPoint+nomp++);
      }
      else {
        if (elb.estDeNatureCalcul(NatCal.NTtCalcNomme)) {
          // CValeurDynamique vald = (CValeurDynamique) elb;
          oldName = elb.getNom();
          newName = nomCalcul+nomc++;
          elb.donneNom(newName);
          // Ajout version 4.9.9. On remet à jour les CCommentaire ou CLateX qui uitiliseraient un affichage dynamique de la valeur
          for (j=i+1; j<lon; j++) {
            e = this.get(j);
            if (e.estDeNature(NatObj.NImplementationProto)) break;
            if (e.estDeNature(NatObj.NComouLatex)) {
              if (e.listeValeursDynamiquesUtilisees.size!==0)
                if (e.remplaceNomValeurDynamique(oldName, newName)) e.determineDependances();
              e.setReady4MathJax();
            }
          }
        }
        // Correction version 4.9.9
        // if (elb.estDeNatureCalcul(NatureCalcul.NCalcOuFoncNonConstante)) {
        //  elb.reconstruitChaineCalcul();
        // }
      }
    }
    k++;
  }
};
/**
 * Fonction utilisée dans les implémentations itératives de constructions.
 * @param {Integer} inddeb
 * @param {CPrototype} proto
 * @param {Integer} nbObjImp
 * @returns {undefined}
 */
CListeObjets.prototype.traiteImplementationsProtoSuccessivesIter = function(inddeb,proto,nbObjImp) {
  var i,ptgen,elb,nomGen,nbfn,k,ch,elg,j,deb,elb2,n,oldName,newName,m,e,vald2;
  var lon = this.longueur();
  var type = Nat.or(NatObj.NTtPoint,NatObj.NDroite,NatObj.NDroiteClone);
  // On commence par renommer les points ou droites qui sont utilisés comme sources qui sont nommés dans le prototype
  for (i = 0; i < proto.nbObjSources; i++) {
    ptgen = proto.get(i);
    elb = ptgen.elementAssocie;
    if (elb.estDeNature(type)) {
      nomGen = ptgen.nom;
      if ((nomGen.length !== 0) && (elb.rendNom().length === 0)) {
        elb.donneNom(this.genereDebutNomPourPoint(inddeb-1));
      }
    }
  }
  // Ensuite on génère des noms pour tous les objets implémentés noms ou droites qui ont un nom
  // On compte le nombre d'objets finaux nommés
  nbfn = 0;
  for (k = proto.nbObjSources; k < proto.longueur(); k++) {
    elb = proto.get(k);
    if (elb.estDeNature(type)) {
       if (elb.rendNom().length!==0) nbfn++;
    }
  }
  ch = this.genereDebutNomPourPoint(inddeb-1); 	// Le début du nom généré qui sera le même pour tous
  // les objets de même type
  k = 0;
  for (i = 0; i < nbObjImp; i++) {
    elb = this.get(inddeb + 1 + i);
    if (elb.estDeNature(type)) {
      elg = proto.get(proto.nbObjSources + i);
      if (elg.rendNom().length!==0) {
        k++;
        elb.donneNom(ch+k);
        j = 1;
        deb = inddeb + 1 + i+j*(nbObjImp+1);
        while (deb < lon) {
          elb2 = this.get(deb);
          n = k+j*nbfn;
          elb2.donneNom(ch+n);
          j++;
          deb = inddeb + 1 + i + j*(nbObjImp+1);
        }
      }
    }
    else {
      if (elb.estDeNatureCalcul(NatCal.NTtCalcNomme)) {
        ch = this.genereDebutNomPourCalcul(Fonte.premiersCaracteresNonChiffresNonPrime(elb.getNom()), inddeb - 1);
        oldName = elb.getNom();
        j = 0;
        deb = inddeb + 1 + i + j*(nbObjImp+1);
        while (deb < lon) {
          vald2 = this.get(deb);
          oldName = vald2.getNom();
          newName = ch+j+1;
          vald2.donneNom(newName);
          for (m=deb+1; m<lon; m++) {
            e = this.get(m);
            if (e.estDeNature(NatObj.NImplementationProto)) break;
            if (e.estDeNature(NatObj.NComouLatex)) {
              if (e.listeValeursDynamiquesUtilisees.size!==0)
                  if (e.remplaceNomValeurDynamique(oldName, newName)) e.determineDependances();
              e.setReady4MathJax();
            }
          }
          j++;
          deb = inddeb + 1 + i + j*(nbObjImp+1);
        }
      }
    }
  }
  // On reconstitue les formules des calculs ou fonctions
  for (i = inddeb + 1; i < lon; i++) {
    elb = this.get(i);
    if (elb.estDeNatureCalcul(NatCal.NCalcOuFoncNonConstante))
      elb.reconstruitChaineCalcul();
  }
  // On met à jour les éléments ajoutés et on les met à jour
  for (i = inddeb + 1; i < lon; i++) {
    elb = this.get(i);
    elb.metAJour();
  }
};

/**
 * Spécial mtgApp : Crée en bas et à droite de la figure des patits dialogues
 * associés aux variables pour lesquelles c'est requis.
 */
CListeObjets.prototype.creePaneVariables = function() {
  var nb = 0;
  for (var i = this.longueur() - 1; i >= 0; i--) {
    var el = this.get(i);
    if (el.getNatureCalcul() === NatCal.NVariable) {
      if (el.dialogueAssocie) {
        el.creeDiv(nb);
        nb++;
      }
    }
  }
};

CListeObjets.prototype.genereNomPourPoint = function(intermPermis) {
  var interm = arguments.length === 0 ? false : intermPermis;
  var ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var nomGenere;
  for (var i = 0;; i++) {
    for (var j = 0; j < ch.length; j++) {
      nomGenere = ch.charAt(j);
      if (i !== 0)
        nomGenere += String(i);
      if (!this.existePointOuDroiteMemeNom(null, nomGenere, interm))
        return nomGenere;
    }
  }
};

/**
 * Spécial version mtgApp
 * Renvoie un nom généré pour un point ou une droite qui commence par car
 * @param car
 * @returns {*}
 */
CListeObjets.prototype.genereNomPourPointOuDroite = function(car, bchiffreImpose) {
  var nomGenere;
  var b = arguments.length === 2 ? bchiffreImpose : false;
  for (var i = b ? 1 : 0;; i++) {
    nomGenere  = car;
    if (i !== 0) nomGenere += i;
    if (!this.existePointOuDroiteMemeNom(null, nomGenere.toString()))
      return nomGenere;
  }
};


/**
 * Spécial version mtgApp.
 * Renvoie true si la liste contient un objet graphique non intermédiaire de nom st
 * autre que el
 * @param el : CElementGraphique
 * @param st : String
 * @returns {boolean}
 */
CListeObjets.prototype.existeMemeNomNonIntermediaire = function(el, st) {
  for (var i = 0; i < this.longueur(); i ++) {
    var elb = this.get(i);
    if (elb.estDeNature(NatObj.NTtObjSaufDuplique) && !elb.estElementIntermediaire() && (elb !== el)) {
      if (elb.nom === st) return true;
    }
  }
  return false;
};

/**
 *
 * @param valeur
 * @param st
 * @param intermPermis
 * @returns {boolean}
 */
CListeObjets.prototype.existeCalculOuVariableOuFonctionOuParametreMemeNom = function(valeur, st, intermPermis) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.estDeNatureCalcul(NatCal.NTtCalcNomme) && (!elb.estElementIntermediaire() || intermPermis) && (elb !== valeur)) {
      // CValeurDynamique ptv = (CValeurDynamique) elb;
      if (elb.getNom() === st) return true;
    }
  }
  return false;
};

/**
 * Spéciail version mtgApp
 * Met à jour dans tous les commentaires les affichages dynamiques
 */
CListeObjets.prototype.determineDependancesCommentaires = function() {
 for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    if (elb.estDeNature(NatObj.NComouLatex)) elb.determineDependances();
  }
};

/**
 * Fonction remplaçant dans tous les objets de la liste l'objet ancienPoint
 * par l'objet nouveauPoint
 */
CListeObjets.prototype.remplacePoint = function(ancienPoint, nouveauPoint) {
  for (var i = 0; i < this.longueur(); i++) {
    var elb = this.get(i);
    elb.remplacePoint(ancienPoint, nouveauPoint);
  }
  // Les listes gérées de façon internes par les macros doivent être mises à jour
  this.etablitListesInternesMacros();
}



// WEBPACK FOOTER //
// ./src/objets/CListeObjets.js